const DEFAULT_LOCAL_API_BASE_URL = "http://localhost:5001";

const LEGACY_API_HOSTNAME_MAP = Object.freeze({
    "balmoral-core-api.vercel.app": "financialedge-core-api.vercel.app",
});

function trimTrailingSlashes(value) {
    return String(value || "").trim().replace(/\/+$/g, "");
}

export function normalizeApiBaseUrl(value) {
    const configuredBaseUrl = trimTrailingSlashes(value);
    if (!configuredBaseUrl) {
        return DEFAULT_LOCAL_API_BASE_URL;
    }

    try {
        const url = new URL(configuredBaseUrl);
        const canonicalHostname = LEGACY_API_HOSTNAME_MAP[url.hostname.toLowerCase()];

        if (canonicalHostname) {
            url.hostname = canonicalHostname;
        }

        return trimTrailingSlashes(url.toString());
    } catch {
        return configuredBaseUrl;
    }
}

export function getApiBaseUrl(env = process.env) {
    return normalizeApiBaseUrl(env.REACT_APP_API_URL || DEFAULT_LOCAL_API_BASE_URL);
}

